module.exports = __webpack_public_path__ + "fonts/didotbold-webfont.ba7b8acb.woff";